module.exports = __webpack_public_path__ + "static/img/kexue2.e9b6489b.webp";